var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcXCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 46.6667L40 40M40 40L46.6667 33.3333M40 40L33.3333 33.3333M40 40L46.6667 46.6667M70 40C70 43.9397 69.224 47.8407 67.7164 51.4805C66.2087 55.1203 63.999 58.4274 61.2132 61.2132C58.4274 63.999 55.1203 66.2087 51.4805 67.7164C47.8407 69.224 43.9397 70 40 70C36.0603 70 32.1593 69.224 28.5195 67.7164C24.8797 66.2087 21.5726 63.999 18.7868 61.2132C16.001 58.4274 13.7913 55.1203 12.2836 51.4805C10.776 47.8407 10 43.9397 10 40C10 32.0435 13.1607 24.4129 18.7868 18.7868C24.4129 13.1607 32.0435 10 40 10C47.9565 10 55.5871 13.1607 61.2132 18.7868C66.8393 24.4129 70 32.0435 70 40Z",
    stroke: "#FF384C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXCircle);
export default __webpack_public_path__ + "static/media/ic_x_circle.047e022eb8b71a4b453434370ab080d8.svg";
export { ForwardRef as ReactComponent };